import React from 'react';

import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';

const propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

const defaultProps = {
  placeholder: 'Filter questions...',
};

export default function QuestionListFilter({ value, onChange, placeholder }) {
  return (
    <Input
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      icon="search"
      fluid
      style={{ marginBottom: '1rem' }}
    />
  );
}

QuestionListFilter.propTypes = propTypes;
QuestionListFilter.defaultProps = defaultProps;
